// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_JWx","cls2":"ChatInterface-cls2_4Ck ChatInterface-cls1_JWx"};